var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23_608)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.7132 16.8978C30.9429 17.1321 31.216 17.318 31.5169 17.4448C31.8177 17.5716 32.1403 17.6367 32.466 17.6364C32.7918 17.6361 33.1143 17.5705 33.4149 17.4432C33.7156 17.3159 33.9884 17.1296 34.2177 16.8948C34.447 16.6601 34.6283 16.3817 34.751 16.0756C34.8738 15.7695 34.9356 15.4417 34.933 15.1113C34.9303 14.7808 34.8632 14.4542 34.7355 14.1502C34.6078 13.8461 34.4221 13.5707 34.189 13.3399C32.1111 11.2532 29.47 9.83824 26.5995 9.27396C23.729 8.70967 20.758 9.02136 18.0622 10.1696C15.3663 11.3179 13.0665 13.2512 11.4536 15.7251C9.84038 18.1991 8.98666 21.1026 9.00016 24.0686C9.0134 27.0346 9.89333 29.9302 11.5286 32.389C13.1639 34.8479 15.481 36.7598 18.1873 37.8828C20.8934 39.0063 23.867 39.2904 26.7323 38.6991C29.5976 38.1082 32.2258 36.669 34.2848 34.563C34.5131 34.3294 34.6937 34.0524 34.8164 33.7477C34.9391 33.4434 35.0015 33.1174 35 32.7882C34.9985 32.4594 34.9331 32.1339 34.8076 31.8306C34.6821 31.5272 34.499 31.2521 34.2686 31.0204C34.0383 30.7889 33.7652 30.6056 33.465 30.4813C33.1649 30.3568 32.8435 30.2936 32.5192 30.2949C32.195 30.2965 31.8742 30.3628 31.5751 30.49C31.2761 30.6175 31.0048 30.8034 30.7765 31.0369C29.4045 32.4412 27.6528 33.4015 25.7429 33.796C23.833 34.1904 21.8506 34.0013 20.0465 33.253C18.2426 32.5046 16.6976 31.2305 15.6074 29.5913C14.5172 27.9525 13.9306 26.0224 13.9215 24.0452C13.9127 22.068 14.482 20.1324 15.5573 18.4834C16.6327 16.8343 18.166 15.5458 19.9632 14.7807C21.7604 14.0155 23.7409 13.8082 25.6543 14.185C27.5677 14.5616 29.328 15.5054 30.7127 16.897L30.7132 16.8978Z",
    fill: "url(#paint0_linear_23_608)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4062 24.0695C19.4062 26.3172 21.2023 28.139 23.4178 28.139C25.6334 28.139 27.4294 26.3172 27.4294 24.0695C27.4294 21.822 25.6334 20 23.4178 20C21.2023 20 19.4062 21.822 19.4062 24.0695Z",
    fill: "url(#paint1_linear_23_608)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_23_608",
    x1: -5.97608,
    y1: 23.9999,
    x2: 46.4921,
    y2: 23.9999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_23_608",
    x1: -5.99524,
    y1: 24.0695,
    x2: 46.4927,
    y2: 24.0695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23_608"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 30,
    fill: "white",
    transform: "translate(9 9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.fd37fd5dd6c6effc5f46f550153d78ca.svg";
export { ForwardRef as ReactComponent };